// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-5b589968] .infinite-scroll-container {
  width: 400px !important;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/MainNav.vue","webpack://./MainNav.vue"],"names":[],"mappings":"AAEA;EACE,uBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n:deep(.infinite-scroll-container) {\n  width: 400px !important;\n}\n",":deep(.infinite-scroll-container) {\n  width: 400px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
